<app-hero image="hero/hero_book.png" title="Confirmer votre venue">
  <span>Merci de confirmer votre présence</span>
  <br />
  <span>Avant le&nbsp;</span>
  <span class="bold">21 mai 2027</span>
</app-hero>
<div class="container-flex">
    <div class="row align-items-center content-container">
        @if (showError()){
        <div class="d-flex align-items-center mb-5 text-danger">
            <h1 role="status"><i class="bi bi-exclamation-triangle ms-5 me-5"></i>Une erreur est survenue
                <br />
                <i class="bi bi-exclamation-triangle ms-5 me-5"></i>Merci de reessayer plus tard
            </h1>
        </div>
        } @else if (showLoader()){
        <div class="d-flex align-items-center mb-5">
            <div class="spinner-border mr-5" aria-hidden="true"></div>
            <strong role="status">Chargement</strong>
        </div>
        } @else if (showPasscode()){
        <div class="col-12 offset-lg-2 col-lg-10 pt-3 row identity-container">
            <div class="col-12 offset-lg-3 col-lg-9 title">
                <h1 class="italic">
                    <i class="bi bi-chat-heart-fill"></i>
                    Votre code d'identification
                </h1>
                <p>
                    <span class="italic bold">Il se trouve sur votre fair-part d'invitation!</span>
                </p>
            </div>
            <div class="offset-lg-3 col-8 col-lg-4">
                <label for="floatingTextareaCode" class="italic">Code *</label>
                <input class="form-control" id="floatingTextareaCode" [formField]="passcodeForm" />
            </div>
            <div class="col-1">
                <button type="button" class="btn btn-terra mt-2 mb-2" (click)="validatePasscode()">
                    <i class="bi bi-check-square-fill"></i>&nbsp;&nbsp;Vérifier
                </button>
                
            </div>
            @if (showPasscodeError()){
                <div class="offset-lg-3 col-8 col-lg-4 text-danger">
                    <span>Code invalide</span>
                </div>
            }
        </div>
        } @else {
        <div class="col-12 offset-lg-2 col-lg-10 pt-3 row identity-container">
            <div class="col-12 offset-lg-3 col-lg-9 title">
                <h1 class="italic">
                    <i class="bi bi-person-vcard"></i>
                    Vos informations
                </h1>
                <img class="separator" src="spot-separator.png" alt="separator" width="70">
            </div>
            <h3>{{!rsvpDataModel().person2 ? 'Adulte' : 'Adultes'}} </h3>
            <div class="col-5 col-lg-4">
                <label for="floatingTextarea1" class="italic">Nom *</label>
                <input class="form-control" id="floatingTextarea1" [formField]="rsvpDataForm.person1.lastName" />
            </div>
            <div class="col-5 col-lg-4">
                <label for="floatingTextarea2" class="italic">Prenom *</label>
                <input class="form-control" id="floatingTextarea2" [formField]="rsvpDataForm.person1.firstName" />
            </div>
            @if (rsvpDataForm.person2) {
            <div class="col-1">
                <i class="bi bi-x delete-icon" (click)="removeAdult('person1')"></i>
            </div>
            <div class="col-5 col-lg-4">
                <label for="floatingTextarea3" class="italic">Nom *</label>
                <input class="form-control" id="floatingTextarea3" [formField]="rsvpDataForm.person2.lastName" />
            </div>
            <div class="col-5 col-lg-4">
                <label for="floatingTextarea4" class="italic">Prenom *</label>
                <input class="form-control" id="floatingTextarea4" [formField]="rsvpDataForm.person2.firstName" />
            </div>
            <div class="col-1">
                <i class="bi bi-x delete-icon" (click)="removeAdult('person2')"></i>
            </div>
            }
        </div>
        <div class="row col-12 offset-lg-2 col-lg-10 pt-3 response-container">
            <div class="col-12 offset-lg-3 col-lg-9 title">
                <h1 class="italic">
                    <i class="bi bi-people-fill"></i>
                    Votre Présence
                </h1>
                <img class="separator" src="spot-separator.png" alt="separator" width="70">
            </div>
            <h3 class="italic mb-2 mt-4 text-black">
                Vous etes invité(s) à la cérémonie@if(isVhOnly()) { et } @else {, } au Vin d'Honneur
                    @if(!isVhOnly()) {
                        et au Repas
                    }
                    
            </h3>
            <div class="col-5 col-lg-4">
                <label for="participationSelect" class="italic">
                    {{(!!rsvpDataModel().childs && rsvpDataModel().childs!.length > 0) || !!rsvpDataModel().person2 ?
                    'Nous serons : *' : 'Je serai : *'}}
                </label>
                <select class="form-select" id="participationSelect" aria-label="Floating label select"
                    [formField]="rsvpDataForm.attendingStatus">
                    @for (option of attendingStatusOptions; track option.getKey()) {
                    <option [selected]="rsvpDataModel().attendingStatus === option.getKey()" [value]="option.getKey()"
                        [disabled]="rsvpDataModel().attendingStatus === option.getKey() || option.getKey() === 'NOT_RESPONDED'">
                        {{ option.getValue() }}
                    </option>
                    }
                </select>
            </div>
            @if (rsvpDataModel().attendingStatus === 'ATTENDING' && !isVhOnly()) {
            <div class="offset-lg-1 col-lg-7 col-12 my-2 my-lg-0 pb-2">
                <div class="form-check">
                    <label for="brunchInput" class="italic">Présent au brunch du dimanche</label>
                    <input class="form-check-input" type="checkbox" role="checkbox" id="brunchInput"
                        [formField]="rsvpDataForm.staysForBrunch">
                </div>
            </div>
            }
        </div>
        <div class="row col-12 offset-lg-2 col-lg-10 pt-3 identity-container">
            @if (!!rsvpDataModel().childs && rsvpDataModel().childs!.length > 0) {
            <h3>{{rsvpDataModel().childs?.length === 1 ? 'Enfant' : 'Enfants'}}</h3>
            }
            @for (child of rsvpDataForm.childs; track $index) {

            <div class="col-5 col-lg-4">
                <label [for]="'floatingTextarea1Child'+$index" class="italic">Nom *</label>
                <input class="form-control" [id]="'floatingTextarea1Child'+$index" [formField]="child.lastName" />
            </div>
            <div class="col-5 col-lg-4">
                <label [for]="'floatingTextarea2Child'+$index" class="italic">Prenom *</label>
                <input class="form-control" [id]="'floatingTextarea2Child'+$index" [formField]="child.firstName" />
            </div>
            <div class="col-1">
                <i class="bi bi-x delete-icon" (click)="removeChild($index)"></i>
            </div>
            }

            <div class="add-buttons-holder col-6">
                @if (canRequireCoupleInvite() && !rsvpDataModel().person2) {
                <button type="button" class="btn btn-black mt-4 mb-4 me-4" (click)="addAdult()">
                    Ajouter un adulte
                </button>
                }
                @if (canRequireChildsInvite()) {
                <button type="button" class="btn btn-black mt-4 mb-4" (click)="addChild()">
                    Ajouter un enfant
                </button>
                }
            </div>
        </div>

        <div class="row col-12 offset-lg-2 col-lg-10 pt-3 response-container">
            <div class="col-12 offset-lg-3 col-lg-9 title">
                <h1 class="italic">
                    <i class="bi bi-pencil-square"></i>
                    Un petit mot
                </h1>
                <img class="separator" src="spot-separator.png" alt="separator" width="70">
            </div>
            <div class="col-8 col-lg-9">
                <label class="italic" for="floatingComment">Commentaire / Question / Allergie</label>
                <textarea class="form-control" placeholder="Laissez nous un message!" id="floatingComment"
                    [formField]="rsvpDataForm.comment!"></textarea>

            </div>

            <div class="col-8 col-lg-9">
                <label class="italic" for="floatingAnswer">Si un paparazzi nous photographiait en secret pendant notre lune de miel, lequel de nous deux serait surpris dans une situation complètement improbable, et laquelle ?</label>
                <textarea class="form-control" [placeholder]=randomPlaceholder() id="floatingAnswer"
                    [formField]="rsvpDataForm.bonusQuestionAnswer!"></textarea>

            </div>

            <div class="add-buttons-holder col-6 mb-4">
                <button type="button" class="btn btn-terra mt-4 mb-4 me-5 px-5" [disabled]="!isFormDirty()"
                    (click)="validate()">
                    {{hasAlreadyAnswered() ? "Modifier " : "Envoyer "}}
                    {{(!!rsvpDataModel().childs && rsvpDataModel().childs!.length > 0) || !!rsvpDataModel().person2 ?
                    'notre ' : 'ma '}}
                    réponse
                </button>
                <button type="button" class="btn btn-white mt-4 mb-4 px-4" [disabled]="!isFormDirty()"
                    (click)="resetForm()">
                    Annuler mes changements
                </button>
            </div>
        </div>
        }
    </div>
</div>